import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  
  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          Voice Agent Generator
        </Link>
        <div className="navbar-links">
          <Link 
            to="/agents" 
            className={`navbar-link ${location.pathname.includes('/agents') ? 'active' : ''}`}
          >
            Agents
          </Link>
          <Link 
            to="/data" 
            className={`navbar-link ${location.pathname === '/data' ? 'active' : ''}`}
          >
            Data
          </Link>
          <Link 
            to="/clients" 
            className={`navbar-link ${location.pathname === '/clients' ? 'active' : ''}`}
          >
            Clients
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
